import { MouseEvent } from 'react';

export const stopPropagation = (event: MouseEvent<any>) => {
  event.stopPropagation();
};

export const preventDefault = (event: MouseEvent<any>) => {
  event.stopPropagation();
};
